export const BASE_URL = "https://www.shakeelhaider.com";

export type SupportedLocale = "ar" | "de" | "el" | "en" | "es" | "fr" | "it" | "ko" | "pl" | "pt" | "ru" | "sv" | "ur" | "zh"
export const DEFAULT_LOCALE: SupportedLocale = "en";
export const SUPPORTED_LOCALES: SupportedLocale[] = ["ar", "de", "el", "en", "es", "fr", "it", "ko", "pl", "pt", "ru", "sv", "ur", "zh"];